import React from 'react'
import AppInfoCollapse from './app_info_collapse/app_info_collapse'
import AppInfoHeader from './app_info_header/app_info_header'
import styles from './app_info.module.css'
import strings from '../../strings/strings.json'
export default function AppInfo(props) {
    const info = JSON.parse(props.data.info)
    return (
        <div className={styles.container}>
            <AppInfoHeader info={info} data={props.data}/>
            <div className={styles.divider} />
            {
                info.Permissions !== undefined &&
                <React.Fragment>
                    <AppInfoCollapse data={info.Permissions} img="permission" title={strings.fileDetail_permissions} />
                    <div className={styles.divider} />
                </React.Fragment>
            }
            {
                info.Activities !== undefined &&
                <React.Fragment>
                    <AppInfoCollapse data={info.Activities} img="activities" title={strings.fileDetail_activities} />
                    <div className={styles.divider} />
                </React.Fragment>
            }
            {
                info.Receivers !== undefined &&
                <React.Fragment>
                    <AppInfoCollapse data={info.Receivers} img="receivers" title={strings.fileDetail_recivers} />
                    <div className={styles.divider} />
                </React.Fragment>
            }
            {
                info.Services !== undefined &&
                <React.Fragment>
                    <AppInfoCollapse data={info.Services} img="services" title={strings.fileDetail_services} />
                    <div className={styles.divider} />
                </React.Fragment>
            }
            {
                info.Providers !== undefined &&
                <React.Fragment>
                    <AppInfoCollapse data={info.Providers} img="providers" title={strings.fileDetail_providers} />
                    <div className={styles.divider} />
                </React.Fragment>
            }
            {
                info.Features !== undefined &&
                <React.Fragment>
                    <AppInfoCollapse data={info.Features} img="features" title={strings.fileDetail_features} />
                    <div className={styles.divider} />
                </React.Fragment>
            }
            {
                (info.urls !== undefined && info.urls.length !== 0) &&
                <React.Fragment>
                    <AppInfoCollapse data={info.urls} img="links" title={strings.fileDetail_urls} />
                    <div className={styles.divider} />
                </React.Fragment>
            }
            {
                (info.Certificates !== undefined && info.Certificates.length !== 0) &&
                <React.Fragment>
                    <AppInfoCollapse is_certificate={true} data={info.Certificates} img="certificates" title={strings.fileDetail_certifcates} />
                </React.Fragment>
            }
        </div>
    )
}